import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks';
import type { PartyCompositionGroup } from '@/scopes/products/user-reviews/types';
import { useIntl } from '@/intl';
import { Icon, Label, tk } from '@sunwebgroup/ui-components';
import { getPartyCompositionType } from '../UserReviews/utils';
import { styled, keyframes } from 'styled-components';

const opacityAnimation = keyframes`
  50% {
    opacity: 0.3;
  }
`;
//To discuss: should we extend this solution to Label component?
const LabelSkeleton = styled(Label)`
  width: 230px;
  height: ${tk('spacing_lg')};
  background: ${tk('color_semantic_bg_disabled')};
  animation-name: ${opacityAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export function MostBookedByLabel() {
  const intl = useIntl();
  const { isLoading, partyCompositionGroups } = useUserReviewsInitialData();

  const mostBookedPartyComposition = partyCompositionGroups?.reduce<PartyCompositionGroup | undefined>(
    (prev, current) => {
      return prev && prev.amount > current.amount ? prev : current;
    },
    undefined
  );

  if (isLoading) {
    return <LabelSkeleton $state="info" />;
  }

  return (
    <Label $state="info">
      <Icon glyph="IconThumbsUp" />
      {intl.formatMessage(
        { id: 'description_most_booked_by_label' },
        {
          partyComposition: intl.formatMessage({
            id: `reviews_party_composition_${getPartyCompositionType(mostBookedPartyComposition?.groupId ?? '')}_label`,
          }),
        }
      )}
    </Label>
  );
}
